// AuthContext.js
import React, { createContext, use, useContext, useEffect, useState } from 'react';
import axios, { refreshTokenRequest } from "../api/axiosInstance"; 
const AuthContext = createContext();

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export function AuthProvider({ children }) {



  const [user, setUserSession] = useState(null);
  const [loading, setLoading] = useState(false);



 
useEffect(() => {
  const initAuth = async () => {
    try {

      await refreshTokenRequest();

      const storedUser = JSON.parse(localStorage.getItem('user'));
   
      if (storedUser) {
  
        setUser(storedUser);
      }
    } catch (err) {
      console.error("Token refresh or user retrieval failed:", err);
    }
  };

  initAuth();
}, []);


  const setUser = (userData) => {
    setUserSession(userData);
  
    console.log('Setting user:', userData);
    // Optionally store user data in localStorage or sessionStorage
  
    if (userData) {
      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('accessToken', userData.accessToken);
      localStorage.setItem('refreshToken', userData.refreshToken);

    } else {
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
    }
  };

  // Normal login
  const login = async (email, password) => {
    setLoading(true);
    try {
      const response = await axios.post('/v1/auth/buddy/login', {
        email,
        password
      });

      const userData = response.data;
      
      return userData;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // Google OAuth login
  const googleLogin = async (token) => {
    setLoading(true);
    try {
      const response = await axios.post('/v1/auth/buddy/googleAuth',{
        token
      });

      const userData =  response.data;
      console.log('Google login response:', userData);
      
      return userData;
    } catch (error) {
      console.error('Google login error:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
  };

  const value = {
    user,
    login,        // Email/password login
    googleLogin,  // Google OAuth login
    logout,
    loading,
    setUser       // Allow setting user directly if needed
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
